


















import { Component, Vue } from 'vue-property-decorator'
import ScrollToTop from '@/apps/open/components/ScrollToTop/index.vue'
import { WWO_DOCS } from '@/apps/open/constants'

interface MenuType {
  id: string,
  text: string,
  link: string,
  isNewTab?: boolean
}

@Component({
  components: {
    ScrollToTop
  }
})
export default class Docs extends Vue {
  activeMenuId: string | undefined = 'kdocs'

  get docMenus (): Array<MenuType> {
    const privateDocMenu: Array<MenuType> = [{
      id: 'enterprise_inner_app',
      text: '企业内部应用',
      link: '/docs/enterprise-inner-app'
    }]
    const priDocMiddleMenu: Array<MenuType> = [{
      id: 'doc-middle-app',
      text: '文档中台应用',
      link: '/docs/middle-app'
    }]
    return this.isPrivate ? this.isPriDocMiddle ? priDocMiddleMenu : privateDocMenu : [{
      id: 'kdocs',
      text: '金山文档',
      link: '/docs/cloud'
    },
    ...privateDocMenu,
    {
      id: 'docs_online_edit',
      text: '文档在线预览编辑',
      link: WWO_DOCS,
      isNewTab: true
    },
    {
      id: 'docs_format_conversion',
      text: '文档格式转换',
      link: '/docs/doc-format-conversion'
    },
    {
      id: 'wps_client_dev',
      text: 'WPS客户端开发',
      link: '/docs/office'
    },
    {
      id: 'wps_ai_open',
      text: 'WPS AI开放能力',
      link: '/docs/doc-ai-open'
    }]
  }

  mounted () {
    this.initActiveMenuId()
  }

  get isPrivate () {
    return this.$store.getters['isPrivate']
  }

  get isPriDocMiddle () {
    return this.$store.getters['isPriDocMiddle']
  }

  initActiveMenuId () {
    const routerPath: string = this.$route.path as string
    const findMenu: MenuType | undefined = this.docMenus.find((menu: MenuType) => routerPath.indexOf(menu.link) > -1)
    this.activeMenuId = findMenu && findMenu.id
  }

  jumpDocs (menu: MenuType) {
    if (menu.link) {
      menu.isNewTab ? window.open(menu.link) : this.jumpHandler(menu)
    }
  }

  jumpHandler (menu: MenuType) {
    this.activeMenuId = menu.id
    this.$router.push({ path: menu.link })
  }
}
